var exports = {
  "my": "avatar__n7OXZd",
  "nb": "issueIcon__XVyYYE",
  "Ls": "commentIcon__S55cWp",
  "Hv": "issueNumberLink__hke_2M",
};

module.exports = exports;
